export const envRawCommon = {
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_COLLECT_SERVER_SIDE_UPLOAD_MEASUREMENT: process.env.NEXT_PUBLIC_COLLECT_SERVER_SIDE_UPLOAD_MEASUREMENT,
  NEXT_PUBLIC_REPORT_SERVER_SIDE_UPLOAD_MEASUREMENT: process.env.NEXT_PUBLIC_REPORT_SERVER_SIDE_UPLOAD_MEASUREMENT
};